import { SHStack, SHToggleButtonOptions } from "@components/design-systems";
import { ToggleButtonOptions } from "@components/design-systems/sh-toggle-button-options/model";
import { FeesPerformanceScope } from "@models/platform-analysis/enums/fee/feesPerformanceScope";
import { useTheme } from "@mui/material";

type FeeAnalysisToggleButtonProps = {
  value: string;
  options: ToggleButtonOptions[];
  disabled?: boolean;
  onChange: (value: FeesPerformanceScope) => void;
};

export const PlatformAnalysisPortfolioFeeTableToggleButton = ({
  value,
  options,
  onChange,
  disabled,
}: FeeAnalysisToggleButtonProps) => {
  const { palette } = useTheme();

  return (
    <SHStack
      alignItems={"center"}
      sx={{
        button: {
          fontWeight: 600,
          fontSize: 14,
          lineHeight: 1.2,
          "&:nth-of-type(1)": {
            "&.Mui-selected": {
              ":before": {
                color: "white",
                content: '"Inc. performance"',
              },
            },
            ":before": {
              color: palette.text.primary,
              content: '"Including"',
            },
          },
          "&:nth-of-type(2)": {
            "&.Mui-selected": {
              ":before": {
                color: "white",
                content: '"Exc. performance"',
              },
            },
            ":before": {
              color: palette.text.primary,
              content: '"Excluding"',
            },
          },
        },
      }}
    >
      <SHToggleButtonOptions
        disabled={disabled}
        options={options}
        value={value}
        onChange={(_, value) => {
          if (!value) return;
          onChange(value);
        }}
      />
    </SHStack>
  );
};
